// Shared CSV export helpers.
//
// Values are RFC 4180-escaped (embedded double quotes doubled) and guarded against
// spreadsheet formula injection: a cell starting with =, +, -, or @ is prefixed with a
// tab so Excel/Sheets treat it as text rather than evaluating it as a formula. Client
// names, packages and free-text reasons are user-influenced, so this must run on export.
export const escapeCsvCell = (value: string): string => {
  const escaped = value.replace(/"/g, '""');
  const safe = /^[=+\-@]/.test(escaped) ? `\t${escaped}` : escaped;
  return `"${safe}"`;
};

// Build RFC 4180-safe CSV content from a header row and body rows.
// RFC 4180 defines records as CRLF-separated, so join with \r\n (Excel/Sheets accept either,
// but strict RFC-4180 parsers expect CRLF).
export const toCsvContent = (headers: string[], rows: string[][]): string =>
  [headers, ...rows].map((row) => row.map(escapeCsvCell).join(',')).join('\r\n');

// Build the CSV and trigger a browser download.
export const downloadCsv = (filename: string, headers: string[], rows: string[][]): void => {
  const blob = new Blob([toCsvContent(headers, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
